// removed by extract-text-webpack-plugin
module.exports = {"quantityControl":"qempo_InputQuantityRound_quantityControl-P0G12Gw","loadingContentCircle":"qempo_InputQuantityRound_loadingContentCircle-3Ub2taE","minus":"qempo_InputQuantityRound_minus-Cu4LCOH","disabled":"qempo_InputQuantityRound_disabled-1K9jnFn","plus":"qempo_InputQuantityRound_plus-3nAMTtv"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/InputQuantityRound/InputQuantityRound.scss
// module id = 1634
// module chunks = 0